import React from 'react';
import StaffMonitoringMap from '../components/StaffMonitoringMap';

const TechnicianPortal = () => {
  return <StaffMonitoringMap role="technician" />;
};

export default TechnicianPortal;
